export function roleHome(role) {
  const r = String(role || '').toLowerCase();
  if (r === 'customer') return '/fleet_dashboard';
  if (r === 'operator' || r === 'technician') return '/select-customer';
  return '/';
}
